import { InventoryLabelAssignRequestSchema, InventoryLabelAssignResponseSchema, InventoryLabelResolveApiResponseSchema, InventoryLabelResolveQuerySchema, LastBarcodeScanApiResponseSchema, } from '../../inventory-label.js';
import { CreateLabelLinkHandheldSessionRequestSchema, CreateLabelLinkHandheldSessionResponseSchema, GetLabelLinkHandheldSessionResponseSchema, LabelLinkSessionIdParamsSchema, } from '../../label-link-handheld-session.js';
import { BaseResponseSchema } from '../../schemas.js';
/** REST contract for `insight-api/src/routes/tenant/inventory-labels.routes.ts`. */
export const inventoryLabelsContract = {
    resolve: {
        method: 'GET',
        path: '/tenant/inventory-labels/resolve',
        query: InventoryLabelResolveQuerySchema,
        response: InventoryLabelResolveApiResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to resolve inventory label',
    },
    getLastScan: {
        method: 'GET',
        path: '/tenant/inventory-labels/last-scan',
        response: LastBarcodeScanApiResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to get last barcode scan',
    },
    assign: {
        method: 'POST',
        path: '/tenant/inventory-labels/assign',
        body: InventoryLabelAssignRequestSchema,
        response: InventoryLabelAssignResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to assign inventory label',
    },
    createHandheldSession: {
        method: 'POST',
        path: '/tenant/inventory-labels/handheld-sessions',
        body: CreateLabelLinkHandheldSessionRequestSchema,
        response: CreateLabelLinkHandheldSessionResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to create label link handheld session',
    },
    getHandheldSession: {
        method: 'GET',
        path: '/tenant/inventory-labels/handheld-sessions/:sessionId',
        pathParams: LabelLinkSessionIdParamsSchema,
        response: GetLabelLinkHandheldSessionResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to get label link handheld session',
    },
    cancelHandheldSession: {
        method: 'DELETE',
        path: '/tenant/inventory-labels/handheld-sessions/:sessionId',
        pathParams: LabelLinkSessionIdParamsSchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to cancel label link handheld session',
    },
    clearHandheldScan: {
        method: 'POST',
        path: '/tenant/inventory-labels/handheld-sessions/:sessionId/next',
        pathParams: LabelLinkSessionIdParamsSchema,
        response: GetLabelLinkHandheldSessionResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to clear handheld scan',
    },
};
//# sourceMappingURL=inventory-labels.contract.js.map